/**
 * Wraps a promise with a timeout. If the promise settles before the timeout,
 * returns its result. If the timeout elapses first, rejects with an Error.
 * Clears the timeout when the promise settles to avoid timer leaks.
 */
export function withTimeout<T>(
	promise: Promise<T>,
	ms: number,
	timeoutMessage: string
): Promise<T> {
	return Promise.race([
		promise,
		new Promise<never>((_, reject) => {
			const id = setTimeout(() => reject(new Error(timeoutMessage)), ms)
			promise.finally(() => clearTimeout(id)).catch(() => {})
		}),
	])
}
